module.exports = {
  /**
   * @type {string}
   * @description 首页三张背景图
   */
  bg1: "https://img.buzzy.top/i/2024/12/26/676cd0e40e4af.webp",
  bg2: "https://img.buzzy.top/i/2024/12/18/67626a9d2ea48.webp",
  bg3: "https://img.buzzy.top/i/2024/12/18/67626a9c6ba40.webp",

  /**
   * @type {string}
   * @description 首页故障风文字
   */
  malfunctionText: "Buzzy' Blog",
};
